var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdministration(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    className: "svg-inline--fa",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 35.723 35.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_193",
    "data-name": "Trac\\xE9 193",
    d: "M20.941,0a3.261,3.261,0,0,0-3.2,3.2v.616H1.355a1.232,1.232,0,0,0,0,2.464H17.738V6.9a3.261,3.261,0,0,0,3.2,3.2H24.76a3.261,3.261,0,0,0,3.2-3.2V6.406h6.282a1.232,1.232,0,1,0,0-2.464H27.963V3.2A3.261,3.261,0,0,0,24.76,0Zm0,2.587H24.76a.582.582,0,0,1,.616.616V7.021a.582.582,0,0,1-.616.616H20.941a.582.582,0,0,1-.616-.616V3.2a.582.582,0,0,1,.616-.616M8.253,12.688a3.261,3.261,0,0,0-3.2,3.2v.616h-3.7A1.349,1.349,0,0,0,0,17.738,1.266,1.266,0,0,0,1.355,18.97H5.174v.616a3.261,3.261,0,0,0,3.2,3.2H12.2a3.261,3.261,0,0,0,3.2-3.2V18.97h18.97a1.349,1.349,0,0,0,1.355-1.232,1.266,1.266,0,0,0-1.355-1.232H15.275v-.616a3.261,3.261,0,0,0-3.2-3.2Zm0,2.587h3.819a.582.582,0,0,1,.616.616v3.819a.582.582,0,0,1-.616.616H8.253a.582.582,0,0,1-.616-.616V15.891A.582.582,0,0,1,8.253,15.275Zm12.688,10.1a3.261,3.261,0,0,0-3.2,3.2v.616H1.232a1.295,1.295,0,1,0,.123,2.587H17.738V32.4a3.261,3.261,0,0,0,3.2,3.2H24.76a3.261,3.261,0,0,0,3.2-3.2v-.616h6.282a1.237,1.237,0,1,0,0-2.464H27.963V28.7a3.261,3.261,0,0,0-3.2-3.2H20.941Zm0,2.464H24.76a.582.582,0,0,1,.616.616v3.819a.582.582,0,0,1-.616.616H20.941a.582.582,0,0,1-.616-.616V28.455a.582.582,0,0,1,.616-.616",
    fill: "current"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministration);
export default __webpack_public_path__ + "static/media/administration.330796ca190c12c07297d681a2730e85.svg";
export { ForwardRef as ReactComponent };